import React from 'react';
import { useTranslation } from 'react-i18next';
import { BankInfo } from '../../components/BankInfo';
import { Layout } from '../../components/layout/redesign/Layout';
import { BigCallToAction } from '../../features/landingMain/CallToAction';
import { LayoutSpacer } from '../../components/BankInfo/LayoutSpacer';

export default function EbasePage() {
  const { t } = useTranslation();

  return (
    <Layout>
      <LayoutSpacer />
      <BankInfo
        bankSlug="ebase"
        title={t(`banks.ebase.title`)}
        calculatorUrl="/fonds-provisionsrechner"
      />
      <BigCallToAction />
    </Layout>
  );
}
